define("shared/components/shared/ui/mobile-redirect-prompt", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cIC--card" ...attributes>
    <div class="cIC--cardHeader u--p__b__xs">
      <p class="cIC--cardHeader__title">
        <span class="u--m__r__sm">{{t "plans.mobile.redirect.icon"}}</span>
        {{this.title}}
      </p>
    </div>
    <div class="cIC--cardBody">
      <p class="u--m__b__0">
        {{this.description}}
        <Shared::Ui::Button
          @class="u--p__0 u--text--hl"
          @onClick={{this.openMobileRedirectModal}}
          @text={{t "shared_phrases.learn_more"}}
          @variant="unstyled"
        />
      </p>
    </div>
  </div>
  */
  {
    "id": "PThZIU4C",
    "block": "[[[11,0],[24,0,\"cIC--card\"],[17,1],[12],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardHeader u--p__b__xs\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"cIC--cardHeader__title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--m__r__sm\"],[12],[1,[28,[35,0],[\"plans.mobile.redirect.icon\"],null]],[13],[1,\"\\n      \"],[1,[30,0,[\"title\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardBody\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n      \"],[1,[30,0,[\"description\"]]],[1,\"\\n      \"],[8,[39,1],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--p__0 u--text--hl\",[30,0,[\"openMobileRedirectModal\"]],[28,[37,0],[\"shared_phrases.learn_more\"],null],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\"],false,[\"t\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/ui/mobile-redirect-prompt.hbs",
    "isStrictMode": false
  });

  let MobileRedirectPromptComponent = (_class = class MobileRedirectPromptComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "subscriptions", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);
    }

    get title() {
      return this.args.title ?? this.intl.t('plans.mobile.redirect.title', {
        platform: this.subscriptions.platform
      });
    }

    get description() {
      return this.args.description ?? this.intl.t('plans.mobile.redirect.description', {
        platform: this.subscriptions.platform
      });
    }

    openMobileRedirectModal() {
      this.subscriptions.openMobileRedirectModal();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openMobileRedirectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMobileRedirectModal"), _class.prototype)), _class);
  _exports.default = MobileRedirectPromptComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MobileRedirectPromptComponent);
});